module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Light-f991a43aa28b295b4afa2f56a8762aab.ttf";